import { useState } from 'react';
import { IconSparklesFilled } from '@tabler/icons-react';
import { apiFetch } from '../api/client';

export default function SKUButton({ onGenerated, disabled }) {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    if (loading || disabled) return;
    setLoading(true);
    const start = Date.now();
    try {
      const res = await apiFetch(`/inventory/sku/generate`);
      const elapsed = Date.now() - start;
      const remaining = Math.max(0, 1000 - elapsed);
      if (remaining > 0) await new Promise((r) => setTimeout(r, remaining));
      if (res.ok) {
        const data = await res.json();
        onGenerated?.(data.sku);
      }
    } catch (e) {
      console.error('Error generating SKU:', e);
    } finally {
      setLoading(false);
    }
  };

  const isDisabled = loading || disabled;

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={isDisabled}
      aria-label="Generar SKU"
      title="Generar SKU"
      className={`flex items-center justify-center shrink-0 rounded-full border-none touch-manipulation select-none transition-colors duration-200 ease-out active:scale-[0.96] ${
        isDisabled ? '' : '[@media(hover:hover)]:hover:bg-white/[0.12]'
      }`}
      style={{
        width: '48px',
        height: '48px',
        backgroundColor: 'rgba(255, 255, 255, 0.06)',
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        opacity: isDisabled ? 0.5 : 1,
      }}
    >
      <span
        className="flex items-center justify-center"
        style={{ animation: loading ? 'sku-spin 1s linear infinite' : 'none' }}
      >
        <IconSparklesFilled size={17} color="rgba(255, 255, 255, 0.85)" />
      </span>
      <style>{`
        @keyframes sku-spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </button>
  );
}
